module.exports = __webpack_public_path__ + "static/media/categories.5f5ee02f.jpg";